<template>
	<div class="container">
		<div class="main_box">
			<!--导航-->
			<navBox :pageName="'关于我们'"></navBox>
			<!--导航-->
			<!--banner-->
			<div
				data-aos="fade-in"
				data-aos-duration="400"
				data-aos-delay="100"
				data-aos-offset="0"
				data-aos-once="true"
				class="banner_box"
			>
				<img src="../../assets/img_public/about/banner01.webp" />
			</div>
			<!--banner-->
			<!--位置-->
			<div class="location_box" >
				<div
					data-aos="fade-left"
					data-aos-duration="400"
					data-aos-delay="200"
					data-aos-offset="0"
					data-aos-once="true"
					class="location_box_main"
				>
					<span @click="goHome" style="color: #333333;cursor: pointer;">首页</span>&ensp;/&ensp;<span>关于我们</span>&ensp;/&ensp;<span>{{ pageTitle }}</span>
				</div>
			</div>
			<!--位置-->
			<!--导航-->
			<div class="nav_box">
				<div
					data-aos="fade-up"
					data-aos-duration="400"
					data-aos-delay="300"
					data-aos-offset="0"
					data-aos-once="true"
					class="nav_box_main"
				>
					<div
						v-for="(value, index) in navList"
						:key="index"
						class="nav_el"
						:class="isActived == index ? 'actived' : ''"
						@click="navChange(index)"
					>
						{{ value.title }}
					</div>
				</div>
			</div>
			<!--导航-->
			<!--企业简介-->
			<template v-if="isActived == 0">
				<gsjj></gsjj>
			</template>
			<!--企业简介-->
			<!--荣誉资质-->
			<template v-if="isActived == 1">
				<ryzz></ryzz>
			</template>
			<!--荣誉资质-->
			<!--企业文化-->
			<template v-if="isActived == 2">
				<qywh></qywh>
			</template>
			<!--企业文化-->
			<!--版权-->
			<footerBox></footerBox>
			<!--版权-->
		</div>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading"><van-loading /></div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
import navBox from '@/component/pc/nav.vue'  //导航组件
import footerBox from '@/component/pc/footer.vue'  //版权组件
import gsjj from './gsjj/index_pc.vue'  //公司简介
import ryzz from './ryzz/index_pc.vue'  //荣誉资质
import qywh from './qywh/index_pc.vue'  //企业文化
export default {
	components:{
		navBox,
		footerBox,
		gsjj,
		ryzz,
		qywh
	},
	data() {
		return {
			isLoading: true,  //界面loading
			navList: [],
			isActived: 0,
			pageTitle: ''
		}
	},
	created(){
		let that = this;
		if(sessionStorage.getItem('navList')) {
			that.navList = JSON.parse(sessionStorage.getItem('navList'))[3].children;
			switch(that.$route.params.aboutId) {
				case 'introduction.html':
					that.isActived = 0;
				break;
				case 'honor.html':
					that.isActived = 1;
				break;
				case 'culture.html':
					that.isActived = 2;
				break;
			}
			that.pageTitle = that.navList[that.isActived].title;
		}
	},
	mounted() {
		let that = this;
		that.isLoading = false;
	},
	watch: {
		//
	},
	methods: {
		goHome() {
			this.$router.push({ path: '/' });
		},
		//nav变化
		navChange(index) {
			let that = this;
			that.isActived = index;
			that.pageTitle = that.navList[that.isActived].title;
		},
	}
}
</script>

<style lang="less" scoped>
.main_box{
	color: #333333;
	//导航
	.nav_box{
		background-color: #F7F8FA;
		.nav_box_main{
			width: 1200px;
			margin: 0 auto;
			padding-bottom: 80px;
			text-align: center;
			.nav_el.actived{
				color: #C8000A;
				border: 1px solid #EEEEEE;
				border-radius: 8px;
			}
			.nav_el{
				display: inline-block;
				margin: 0 15px;
				padding: 10px 40px;
				font-size: 16px;
				cursor: pointer;
			}
		}
	}
	//位置
	.location_box{
		background-color: #F7F8FA;
		.location_box_main{
			width: 1200px;
			margin: 0 auto;
			padding: 40px 0;
			span{
				color: #999999;
			}
		}
	}
	//banner
	.banner_box{
		min-width: 1200px;
		img{
			width: 100%;
		}
	}
}
</style>